import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
// import { crearCategoria, modificarCategoria } from "../../../api/api-categoria";
// import cargandoCard from "../../../components/cargando-card";
// import { obtenerListaCategoria } from "../../../api/api-categoria";
import Select from "react-select";
import { useConceptoTipoUsuarioMovil } from "./concepto-tipo-usuario-movil";
// import { actualizarProducto, crearProducto } from "../../../api/api-producto";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { actualizarTipoUsuarioMovil, crearTipoUsuarioMovil } from "../../../api/api-tipo-usuario-movil";
import { obtenerListaGrupos, obtenerListaSubGrupos } from "../../../api/gestion-dts/api-rastreo-v4";
import { INT_TIPO_USUARIO_MOVIL } from "../../../utils/const/int-const";
import { obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
import SwitchComponent from "../../../components/switch";
import { sharedParseSelectMultiField, sharedDedupeSelectOptions } from "../../../utils/shared-functions";

export default function TipoUsuarioMovilPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const listaTipoUsuarioMovil = useConceptoTipoUsuarioMovil();
  const [tipoUsuarioMovilSelected, setTipoUsuarioMovilSelected] = useState(listaTipoUsuarioMovil.find((item) => item.value === INT_TIPO_USUARIO_MOVIL.USUARIO_SINGULAR));

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  const [listaUnidades, setListaUnidades] = useState([]);
  const [unidadesSelected, setUnidadesSelected] = useState(null);

  const [listaGrupos, setListaGrupos] = useState([]);
  const [grupoSelected, setGrupoSelected] = useState(null);

  const [listaSubGrupos, setListaSubGrupos] = useState([]);
  const [subGrupoSelected, setSubGrupoSelected] = useState(null);

  const prevTipoUsuarioMovilRef = useRef(null);
  const subGrupoFetchIdRef = useRef(0);

  const [switchPuedeHacerGestionEstregeRecogoProductos, setSwitchPuedeHacerGestionEstregeRecogoProductos] = useState(false);
  const [switchEsChofer, setSwitchEsChofer] = useState(false);
  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      let listaGruposEmpresa = await obtenerListaGrupos();
      // console.log('listaGruposEmpresa');
      // console.log(listaGruposEmpresa);
      if (listaGruposEmpresa.error === false && Array.isArray(listaGruposEmpresa.data) && listaGruposEmpresa.data.length > 0) {
        setListaGrupos(listaGruposEmpresa.data);
      }
      const todasLasUnidades = await obtenerTodasLasUnidades();
      // console.log('todasLasUnidades');
      // console.log(todasLasUnidades);
      if (Array.isArray(todasLasUnidades) && todasLasUnidades.length > 0) {
        setListaUnidades(todasLasUnidades);
      }
      if (data.params.idConcepto !== undefined && data.params.idConcepto !== null) {
        const tipoUsuarioMovil = listaTipoUsuarioMovil.find((item) => item.value === data.params.idConcepto);
        // console.log("tipoUsuarioMovil");
        // console.log(tipoUsuarioMovil);
        if (tipoUsuarioMovil !== undefined && tipoUsuarioMovil !== null) {
          setTipoUsuarioMovilSelected(tipoUsuarioMovil);
          if (tipoUsuarioMovil.value === INT_TIPO_USUARIO_MOVIL.TRANSPORTADORA_SINDICATO) {
            const grupoParsed = sharedParseSelectMultiField(data.params.grupo);
            if (grupoParsed) {
              setGrupoSelected(grupoParsed);
            }
            const subGrupoParsed = sharedParseSelectMultiField(data.params.subGrupo);
            if (subGrupoParsed) {
              setSubGrupoSelected(subGrupoParsed);
            }
            const unidadesParsed = sharedParseSelectMultiField(data.params.unidades);
            if (unidadesParsed) {
              setUnidadesSelected(unidadesParsed);
            }
          }
        }
      }
      if (data.params.puedeHacerGestionEstregeRecogoProductos !== undefined && data.params.puedeHacerGestionEstregeRecogoProductos !== null) {
        setSwitchPuedeHacerGestionEstregeRecogoProductos(data.params.puedeHacerGestionEstregeRecogoProductos);
      }
      if (data.params.esChofer !== undefined && data.params.esChofer !== null) {
        setSwitchEsChofer(data.params.esChofer);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  // Reset grupo/subgrupo only when the user changes tipo (not on initial edit load).
  useEffect(() => {
    if (tipoUsuarioMovilSelected == null) return;
    const prev = prevTipoUsuarioMovilRef.current;
    const next = tipoUsuarioMovilSelected.value;
    if (prev != null && prev !== next) {
      setGrupoSelected(null);
      setSubGrupoSelected(null);
      setUnidadesSelected(null);
      setListaSubGrupos([]);
    }
    prevTipoUsuarioMovilRef.current = next;
  }, [tipoUsuarioMovilSelected]);

  useEffect(() => {
    if (grupoSelected !== null && Array.isArray(grupoSelected) && grupoSelected.length > 0) {
      obtenerListaSubGrupo(grupoSelected);
    } else {
      setListaSubGrupos([]);
      setSubGrupoSelected(null);
    }
  }, [grupoSelected]);

  const obtenerListaSubGrupo = async (grupos) => {
    const fetchId = ++subGrupoFetchIdRef.current;
    try {
      setProcessingVisible(true);
      const responses = await Promise.all(
        grupos.map((grupo) => obtenerListaSubGrupos({ idGrupo: grupo.value }))
      );

      if (fetchId !== subGrupoFetchIdRef.current) return;

      const merged = [];
      for (const res of responses) {
        if (res.error === false && Array.isArray(res.data) && res.data.length > 0) {
          merged.push(...res.data);
        }
      }

      const deduped = sharedDedupeSelectOptions(merged);
      setListaSubGrupos(deduped);

      setSubGrupoSelected((prev) => {
        if (!Array.isArray(prev) || prev.length === 0) return prev;
        const allowed = new Set(deduped.map((opt) => opt.value));
        const filtered = prev.filter((opt) => allowed.has(opt.value));
        return filtered.length > 0 ? sharedDedupeSelectOptions(filtered) : null;
      });
    } catch (err) {
      console.log("obtenerListaSubGrupo err");
      console.log(err);
    } finally {
      if (fetchId === subGrupoFetchIdRef.current) {
        setProcessingVisible(false);
      }
    }
  };

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (tipoUsuarioMovilSelected === null) {
        message = message + t("alert_debe_seleccionar_tipo_usuario_movil") + '\n';
      }

      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.idConcepto = tipoUsuarioMovilSelected.value;
    objEnviar.grupo = grupoSelected;
    objEnviar.subGrupo = subGrupoSelected;
    objEnviar.unidades = unidadesSelected;
    objEnviar.puedeHacerGestionEstregeRecogoProductos = switchPuedeHacerGestionEstregeRecogoProductos;
    objEnviar.esChofer = switchEsChofer;
    setProcessingVisible(true);
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await crearTipoUsuarioMovil(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear"));
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await actualizarTipoUsuarioMovil(objEnviar);
      setProcessingVisible(false);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar"));
      }
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="tipo_usuario_movil">
                  {t("label_tipo_usuario_movil")}<span className="text-red-500">*</span>
                </label>
                <Select options={listaTipoUsuarioMovil}
                  isSearchable={true}
                  isClearable={true}
                  value={tipoUsuarioMovilSelected}
                  onChange={(event) => setTipoUsuarioMovilSelected(event)}
                  placeholder={t("placeholder_seleccione_tipo_usuario_movil")}
                />
              </div>
            </div>
            {tipoUsuarioMovilSelected?.value === INT_TIPO_USUARIO_MOVIL.TRANSPORTADORA_SINDICATO &&
              <div className="grid grid-cols-12 gap-4 mt-4">
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold" htmlFor="grupo">
                    {t("label_grupo")}
                  </label>
                  <Select
                    options={listaGrupos}
                    isSearchable={true}
                    isClearable={true}
                    isMulti={true}
                    value={grupoSelected}
                    onChange={(event) => setGrupoSelected(event)}
                    placeholder={t("placeholder_seleccione_grupo")}
                  />
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold" htmlFor="sub_grupo">
                    {t("label_sub_grupo")}
                  </label>
                  <Select
                    options={listaSubGrupos}
                    isSearchable={true}
                    isClearable={true}
                    isMulti={true}
                    value={subGrupoSelected}
                    onChange={(event) =>
                      setSubGrupoSelected(
                        Array.isArray(event) ? sharedDedupeSelectOptions(event) : event
                      )
                    }
                    placeholder={t("placeholder_seleccione_sub_grupo")}
                  />
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold" htmlFor="unidades">
                    {t("label_vehiculos")}
                  </label>
                  <Select
                    options={listaUnidades}
                    isSearchable={true}
                    isClearable={true}
                    isMulti={true}
                    value={unidadesSelected}
                    onChange={(event) => setUnidadesSelected(event)}
                    placeholder={t("placeholder_seleccione_vehiculos")}
                  />
                </div>
              </div>
            }
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nombre"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            {/* <br /> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_este_usuario_puede_hacer_gestion_estrege_recogo_productos")}
                </label>
                <SwitchComponent
                  checked={switchPuedeHacerGestionEstregeRecogoProductos}
                  onChange={() => setSwitchPuedeHacerGestionEstregeRecogoProductos(!switchPuedeHacerGestionEstregeRecogoProductos)}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_es_chofer")}
                </label>
                <SwitchComponent
                  checked={switchEsChofer}
                  onChange={() => setSwitchEsChofer(!switchEsChofer)}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    onClick={handleSaveClick}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
